import React, { useMemo } from "react";

import {
	AttachmentType,
	AttachmentTypeDisplayNames,
	PropertyDocumentsType,
	warrantyType
} from "constants/field-values";
import { getFirebaseFileInfo } from "utils/files-management";

interface AttachmentItemProps {
	name?: string;
	file?: any;
	fileUrl?: string;
	type?: AttachmentType | string;
	onRemove: () => void;
	showEditButton?: boolean;
	onEdit?: () => void;
	handleOnClick?: () => void;
	editMode?: boolean;
}

const AttachmentItem: React.FC<AttachmentItemProps> = ({
	name,
	file,
	type,
	fileUrl,
	onRemove,
	showEditButton,
	onEdit,
	handleOnClick,
	editMode
}) => {
	const attachmentIcon = useMemo(() => {
		let imgSrc = ``;
		let fileTypeImgSrc = "";
		let fileInfoImgSrc = "";

		if (fileUrl) {
			const fileInfo = getFirebaseFileInfo(fileUrl);

			switch (fileInfo.fileType) {
				case "image":
				case "video":
				case "audio":
					fileInfoImgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-video-grey.svg`;
					break;
				case "document":
					fileInfoImgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-manual-grey.svg`;
					break;
				default:
					fileInfoImgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc-grey.svg`;
					break;
			}
		}

		if (file && file.type) {
			const fileType = file?.type.split("/")[0];

			switch (fileType) {
				case "image":
				case "photo":
				case "video":
				case "audio":
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-video-grey.svg`;
					fileTypeImgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-video-grey.svg`;
					break;
				default:
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-manual-grey.svg`;
					fileTypeImgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-manual-grey.svg`;
					break;
			}

			if (type && type === AttachmentType.DIAGRAM) {
				imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc-grey.svg`;
			}
		}

		if (type) {
			switch (type) {
				case AttachmentType.MANUAL:
				case AttachmentType.GENERAL_DOCUMENT:
				case AttachmentType.TECHNICAL_DOCUMENT:
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-manual-grey.svg`;
					break;
				case AttachmentType.PHOTO:
				case AttachmentType.AUDIO:
				case AttachmentType.VIDEO:
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-video-grey.svg`;
					break;
				case AttachmentType.DIAGRAM:
				case PropertyDocumentsType.FLOOR_PLAN:
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc-grey.svg`;
					break;
				case PropertyDocumentsType.DESIGN:
				case PropertyDocumentsType.MARKUPS:
				case PropertyDocumentsType.OTHER:
					if (fileInfoImgSrc) {
						imgSrc = fileInfoImgSrc;
					} else if (fileTypeImgSrc) {
						imgSrc = fileTypeImgSrc;
					} else {
						imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc-grey.svg`;
					}
					break;
				case warrantyType:
					imgSrc = `${process.env.PUBLIC_URL}/assets/images/icons/attachment-doc-grey.svg`;
					break;
				default:
					return null;
			}
		}

		return <img src={imgSrc} className="selected-file-icon type" />;
	}, [file, fileUrl]);

	return (
		<div className="attachment-item">
			<div className="selected-file-icon-container" onClick={handleOnClick}>
				{attachmentIcon}
			</div>
			<span className="selected-file-name">
				{name || file?.name || (type ? (AttachmentTypeDisplayNames[type as AttachmentType] ?? type) : "") || ""}
			</span>
			{showEditButton ? (
				<img
					alt={`edit-attachment-icon`}
					src={`${process.env.PUBLIC_URL}/assets/images/icons/edit-pencil.svg`}
					className="selected-file-icon"
					onClick={onEdit}
				/>
			) : null}
			{editMode ? null : (
				<img
					alt={`remove-attachment-icon`}
					src={`${process.env.PUBLIC_URL}/assets/images/icons/remove-trash.svg`}
					className="selected-file-icon"
					onClick={onRemove}
				/>
			)}
		</div>
	);
};

export default AttachmentItem;
